/**
 * @desc 获取问卷问题列表
 * @see http://api.umucdn.cn/project/51/interface/api/2576
 */
import Api from '../../../path';
import { fetch } from '@umu/umu-fetch';

interface IInput {
    element_id: number;
    page: number;
    size: number;
}
/**
 * @desc 获取问题列表
 * @param elementId
 * @param page
 * @param size
 */
export const getQuestionList = (param: IInput) => {
    return fetch.get(Api.GET_SURVEY_LIST.url, param).then((res: { data: IList<ISurveySectionInfo> }) => {
        return res.data;
    });
};
